module.exports = __webpack_public_path__ + "img/preview_vanags.cc93e451.gif";